import Handlebars from 'handlebars';
import {checkOrder, eachVersion, getSaveMessage, ifEq, tagWeight, warn} from './views/stories/storyUtils';
import {
    convertTime,
    displayDate,
    displayDateAndTime,
    displayDateTime,
    stripUrlDate,
} from '@sinclair-digital/sbg-storyline-components/src/util/date-utils';

/* global globalThis */

/* eslint-disable max-statements */
export const registerHandlebarHelpers = (appContext) => {
    Handlebars.registerHelper('checkOrder', checkOrder);
    Handlebars.registerHelper('convertTime', convertTime);
    Handlebars.registerHelper('displayDate', displayDate);
    Handlebars.registerHelper('displayDateAndTime', displayDateAndTime);
    Handlebars.registerHelper('displayDateTime', displayDateTime);
    Handlebars.registerHelper('each_version', eachVersion);
    Handlebars.registerHelper('getSaveMessage', getSaveMessage);
    Handlebars.registerHelper('if_eq', ifEq);
    Handlebars.registerHelper('stripUrlDate', stripUrlDate);
    Handlebars.registerHelper('tagWeight', tagWeight);
    Handlebars.registerHelper('warn', warn);
    Handlebars.registerHelper('toLowerCase', str => str.toLowerCase());

    const conditional = (v1, operator, v2) => {
        switch (operator) {
            case '==':
            case '===':
                return v1 === v2;
            case '<':
                return v1 < v2;
            case '<=':
                return v1 <= v2;
            case '>':
                return v1 > v2;
            case '>=':
                return v1 >= v2;
            case '&&':
                return v1 && v2;
            case '||':
                return v1 || v2;
            case '!==':
                return v1 !== v2;
            default:
                return false;
        }
    };
    Handlebars.registerHelper('ifCond', function(v1, operator, v2, options) {
        return conditional(v1, operator, v2) ? options.fn(this) : options.inverse(this);
    });

    Handlebars.registerHelper('ifArrayHasValue', (array, value, options) => {
        if (Array.isArray(array) && array.includes(value)) {
            return options.fn(this);
        }
        return options.inverse(this);
    });

    Handlebars.registerHelper('ifUserHasPermission', function(permissionSet, uuid, options) {
        const hasPermission = appContext.hasUserPermissionSet(permissionSet, uuid);

        return hasPermission ? options.fn(this) : options.inverse(this);
    });

    Handlebars.registerHelper('ifUserHasAnyPermission', function(permissionSet, options) {
        const hasPermission = appContext.hasAnyPermissionSet(permissionSet);

        return hasPermission ? options.fn(this) : options.inverse(this);
    });

    Handlebars.registerHelper('ifFeatureFlagEnabled', function(featureFlag, options) {
        return appContext.getFeatureFlag(featureFlag) ? options.fn(this) : options.inverse(this);
    });

    Handlebars.registerHelper('bankrateEnabledAndReadOnlyStory', function (isreadonly, type, featureFlag) {
        return appContext.getFeatureFlag(featureFlag) ? (isreadonly && type === 'story') : false;
    });

    // eslint-disable-next-line no-console
    Handlebars.registerHelper('consoleLog', obj => console.log(obj));

    Handlebars.registerHelper(
        'mediaIcon',
        mediaType =>
            ({
                video: 'play',
                image: 'image',
                audio: 'volume-off',
            }[mediaType] || 'image'),
    );

    Handlebars.registerHelper('jsonStringify', function(json) {
        try {
            return JSON.stringify(json);
        } catch (e) {
            console.error('jsonStringify parse error', e);
        }

        return '';
    });

    Handlebars.registerHelper('secure', function(input) {
        return input.replace('http:', 'https:');
    });

    Handlebars.registerHelper(
        'anchorHrefFormat',
        // eslint-disable-next-line complexity
        function anchorHrefFormat(str) {
            const isNeoStoryline = globalThis.storylineSDK?.isNeoStoryline?.() ?? false;

            if (isNeoStoryline && str.startsWith('#')) {
                return str.replace(/^#/, '/')
                    .replace(/^\/{2,}/, '/');
            }
            if (isNeoStoryline && str.includes('#')) {
                // eslint-disable-next-line no-console
                console.warn(`verify that ${str} is the expected href for this link`);
            }
            if (!isNeoStoryline && str.startsWith('/') && str !== '/') {
                return str.replace(/^\//, '#');
            }
            return str;
        }
    );
};
